export class PlotSeedLandingReleaseFilterVM {
  salesManagerAccountNumberList: number;
  salesManagerAccountNameList: any;
  orderHeaderIdList: number;
  accountNumberList: number;
  accountNameList: any;
  parentAccountNumberList: number;
  parentAccountNameList: any;
  cropTypeCode: string;
  brandList: string;
  maturity: any;
  status: string;
}
